export * from './Editor_DeployDemoPatient.js';
//# sourceMappingURL=index.js.map